import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Alert, AlertService, AlertType } from '@michelin/theme';
import { AuthService } from 'src/app/shared/services/auth/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
    standalone: false
})
export class LoginComponent {
  hide = true;
  image = true;
  loading = false;
  loginForm: FormGroup = null;

  constructor(private form: FormBuilder, private alertService: AlertService, private authService: AuthService, private router: Router) {
    this.loginForm = this.form.group({
      username: this.form.control('', [Validators.required]),
      password: this.form.control('', [Validators.required])
    });
  }

  login() {
    if (this.loginForm.invalid) {
      return this.alertService.showAlert({
        type: AlertType.strong,
        content: 'Preencha o formulário corretamente!',
        timestamp: 5000
      } as Alert);
    }

    const loginRequest = {
      username: this.loginForm.get('username').value,
      password: this.loginForm.get('password').value
    };

    this.loading = true;

    this.authService
      .login(loginRequest)
      .subscribe({
        next: (value) => {
          this.authService.storeUserData(value);
          this.router.navigate(['']);
        },
        error: () =>
          this.alertService.showAlert({
            type: AlertType.strong,
            content: 'Usuário e/ou senha inválidos!',
            timestamp: 5000
          } as Alert)
      })
      .add(() => (this.loading = false));
  }
}
